export const demoProducts = [];

export function normalizePhone(phone = '') {
  return String(phone).replace(/\D+/g, '');
}

export function getCustomerDocId(phone = '') {
  const normalized = normalizePhone(phone);
  return normalized ? `cust_${normalized}` : '';
}

export function normalizeQty(value, fallback = 1) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return fallback;
  return Math.round(parsed * 1000) / 1000;
}

export function getPriceForQty(product, qty) {
  const baseQty = normalizeQty(product?.baseQty, 0.5);
  const parsedQty = normalizeQty(qty, baseQty);
  const rules = Array.isArray(product?.priceRules) ? [...product.priceRules] : [];
  rules.sort((a, b) => Number(a.qty || 0) - Number(b.qty || 0));

  const basePrice = Number(product?.basePrice || 0);
  const baseUnitPrice = baseQty > 0 ? basePrice / baseQty : basePrice;
  let matchedPrice = baseUnitPrice * parsedQty;
  let unitPrice = parsedQty ? matchedPrice / parsedQty : baseUnitPrice;
  let matchedRule = null;

  for (const rule of rules) {
    if (parsedQty >= Number(rule.qty || 0)) {
      matchedPrice = Number(rule.price || matchedPrice);
      unitPrice = parsedQty ? matchedPrice / parsedQty : baseUnitPrice;
      matchedRule = rule;
    }
  }

  return {
    qty: parsedQty,
    totalPrice: Number(matchedPrice || 0),
    unitPrice: Number(unitPrice || 0),
    matchedRule,
  };
}

export function formatMoney(value) {
  return `R ${Number(value || 0).toFixed(2)}`;
}

export function formatQty(value) {
  const qty = Number(value || 0);
  if (!Number.isFinite(qty)) return '0';
  const rounded = Math.round(qty * 1000) / 1000;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded).replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
}
